<template>
  <v-card flat>
    <v-expansion-panels>
      <v-expansion-panel>
        <v-expansion-panel-header>
          <div class="body-2">Reinsurance – Cedant’s Information</div>
        </v-expansion-panel-header>
        <v-expansion-panel-content>
          <v-card-text>
            <v-container fluid grid-list-sm>
              <v-layout row wrap xs12>
                <v-flex xs4>
                  <v-subheader class="queryLabel">Cedant Name</v-subheader>
                </v-flex>
                <v-flex xs8>
                  <strong v-if="riDetail.cedAnt">{{ riDetail.cedAnt }} - {{ riDetail.cedAntName }}</strong>
                  <span v-else> - </span>
                </v-flex>
                <v-flex xs4>
                  <v-subheader class="queryLabel">Suffix</v-subheader>
                </v-flex>
                <v-flex xs8>
                  <span v-if="riDetail.cedAcctNoSfx">{{ riDetail.cedAcctNoSfx }} - {{ riDetail.acctNoSfxDesc }}</span>
                  <span v-else> - </span>
                </v-flex>
                <v-flex xs4>
                  <v-subheader class="queryLabel">Reciprocal Business</v-subheader>
                </v-flex>
                <v-flex xs8>
                  <span v-if="riDetail.recip">{{ riDetail.recip }}</span>
                  <span v-else> - </span>
                </v-flex>
                <v-flex xs4>
                  <v-subheader class="queryLabel">Cedant Policy No.</v-subheader>
                </v-flex>
                <v-flex xs8>
                  <span v-if="riDetail.cedPolNo">{{ riDetail.cedPolNo }}</span>
                  <span v-else> - </span>
                </v-flex>
                <v-flex xs4>
                  <v-subheader class="queryLabel">Cession No.</v-subheader>
                </v-flex>
                <v-flex xs8>
                  <span v-if="riDetail.cedCesNo">{{ riDetail.cedCesNo }}</span>
                  <span v-else> - </span>
                </v-flex>
                <v-flex xs4>
                  <v-subheader class="queryLabel">Cedant SI</v-subheader>
                </v-flex>
                <v-flex xs8>
                  <span>{{ formatDisplayNumber(riDetail.cedSI, 2) }}</span>
                </v-flex>
                <v-flex xs4>
                  <v-subheader class="queryLabel">Our Shared</v-subheader>
                </v-flex>
                <v-flex xs8>
                  <span>{{ formatDisplayNumber(riDetail.ourSharePct, 6) }}</span>
                </v-flex>
              </v-layout>
            </v-container>
          </v-card-text>
        </v-expansion-panel-content>
      </v-expansion-panel>
    </v-expansion-panels>
    <v-divider class="grey lighten-3"></v-divider>
    <v-expansion-panels>
      <v-expansion-panel>
        <v-expansion-panel-header>
          <div class="body-2">Contract Certainty Dates</div>
        </v-expansion-panel-header>
        <v-expansion-panel-content>
          <v-card-text>
            <v-container fluid grid-list-sm>
              <v-layout row wrap xs12>
                <v-flex xs4>
                  <v-subheader class="queryLabel">Acceptance Date</v-subheader>
                </v-flex>
                <v-flex xs8>
                  <span v-if="riDetail.ccaDate">{{ formatDate(riDetail.ccaDate) }}</span>
                  <span v-else> - </span>
                </v-flex>
                <v-flex xs4>
                  <v-subheader class="queryLabel">Documentation Date</v-subheader>
                </v-flex>
                <v-flex xs8>
                  <span v-if="riDetail.ccdDate">{{ formatDate(riDetail.ccdDate) }}</span>
                  <span v-else> - </span>
                </v-flex>
              </v-layout>
            </v-container>
          </v-card-text>
        </v-expansion-panel-content>
        <v-expansion-panel-content>
          <div slot="header" class="body-2">Coinsurance Information</div>
          <v-card-text>
            <v-container fluid grid-list-sm>
              <v-layout row wrap xs12>
                <v-flex xs4>
                  <v-subheader class="queryLabel">Apply Coinsurance</v-subheader>
                </v-flex>
                <v-flex xs8>
                  <span v-if="riDetail.appCoIns === true">{{ formatBoolean(riDetail.appCoIns) }}</span>
                  <span v-else>{{ formatBoolean(riDetail.appCoIns) }}</span>
                </v-flex>
                <v-flex xs4>
                  <v-subheader class="queryLabel">Bill Coinsurance</v-subheader>
                </v-flex>
                <v-flex xs8>
                  <span>{{ riDetail.billCoIns }}</span>
                </v-flex>
                <v-flex xs4>
                  <v-subheader class="queryLabel">Coinsurance %</v-subheader>
                </v-flex>
                <v-flex xs8>
                  <span>{{ formatDisplayNumber(riDetail.coInsPct, 6) }}</span>
                </v-flex>
              </v-layout>
            </v-container>
          </v-card-text>
        </v-expansion-panel-content>
      </v-expansion-panel>
    </v-expansion-panels>
  </v-card>
</template>

<script>
import { formatDisplayDate } from '@/utils/date'
import { formatDisplayNumber } from '@/utils/number'

export default {
  computed: {
    riDetailListing() {
      return this.$store.state.reinsurance.riDetailListing
    },
    riDetail() {
      return this.riDetailListing.riDetail
    }
  },
  methods: {
    formatDate(date) {
      return formatDisplayDate(date)
    },
    formatDisplayNumber(val, scale) {
      return formatDisplayNumber(val, scale)
    },
    formatBoolean(value) {
      if (value) {
        return 'Yes'
      }
      return 'No'
    }
  },
  data() {
    return {
      panel: [true, true]
    }
  },
  props: {
    query: {
      type: Boolean,
      default: false
    }
  }
}
</script>
